import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { Paragraph } from 'components/patterns/Typography'
import { StyledParagraph } from './SimpleList.style'

const SimpleList = ({ heading, collection }) => {
  if (isEmpty(collection)) {
    return null
  }

  const renderListItem = (item) => (
    <li key={item}>
      <StyledParagraph size="small">{item}</StyledParagraph>
    </li>
  )

  return (
    <>
      <Paragraph size="small" weight="bold">
        {heading}
      </Paragraph>
      <ul>{collection.map(renderListItem)}</ul>
    </>
  )
}

SimpleList.propTypes = {
  heading: PropTypes.string,
  collection: PropTypes.array,
}

export default SimpleList
